/* global jQuery, themeVariables */
import jQuery from 'jquery';
import Svg4Everybody from 'svg4everybody';
// import Ps from 'perfect-scrollbar';
// import Select2 from 'select2';
import AOS from 'aos';
import objectFitImages from 'object-fit-images';
// Relative Imports
// import Filters from './modules/filters';
// import Sorters from './modules/sorters';
// import SocialSharing from './modules/social-sharing';

import Accordion from './modules/accordion';
import BackToTop from "./modules/back-to-top";
import Header from "./modules/header";
import Media from "./modules/media";
import DragScroll from "./modules/drag-scroll";
import SlickCarousel from "./modules/slick-carousel";
// import LottiePlayer from './modules/lottie';
// import LottieInteractivity from "./modules/lottie";
import $ from "jquery";

(function ($) {
    // In functions-config.php we are passing `themeVariables` to push PHP
    // values to JS console.log(themeVariables);

    // Polyfills
    new Svg4Everybody();
    objectFitImages();
    AOS.init({
        easing: 'ease-out-back',
        duration: 1000
    });

    // Classes
    // new AnimateNumbers();
    // new Filters('.js-filters');


    /**
     * Accordion
     */
    new Accordion();
    new BackToTop();
    new Header();
    new Media();
    // new SlickCarousel();
    new DragScroll();
    /**
     * Slick Carousel
     */
    new SlickCarousel();
    // new LottiePlayer();
    // new HorizontalScrolling();
    // new SocialSharing('.js-social-share');


    /* custom */
    $(function () {
        this.$document = $(document);
        this.$window = $(window);
        const slide_1 = $(".c-home-banner__slide--1");
        const slide_2 = $(".c-home-banner__slide--2");
        this.$document.ready(function () {
            slide_1.addClass("in-view");
        })
        this.$window.scroll(function () {
            var scroll = $(window).scrollTop();

            if (scroll >= 100) {
                slide_1.removeClass("in-view");
                slide_2.addClass("in-view");
            } else {
                slide_1.addClass("in-view");
                slide_2.removeClass("in-view");
            }
        });

        // Filters
        $(document).on("click", "a", function (e) {
            $('.c-listing-block__filter-item').removeClass('active');
            $(this).addClass('active');
            $.ajax({
                type: 'POST',
                url: '/wp-admin/admin-ajax.php',
                dataType: 'html',
                data: {
                    action: 'filter_projects',
                    // category: $(this).data('slug'),
                    category: $(this).data('slug'),
                },
                success: function (res) {
                    $('.project-tiles').html(res);
                }
            })
        });
    });


}(jQuery));

